import { schema } from 'normalizr';

export const accountSchema = new schema.Entity('accounts', {});

export const contactSchema = new schema.Entity('contacts', {
  account: accountSchema,
});
